import type { Plan } from "../../shared/design/design.types";

export type SubscriptionPlanCard = {
  id: Plan;
  name: string;
  price: string;
  studentPrice?: string;
  description: string;
  features: string[];
};

export const subscriptionPlans: SubscriptionPlanCard[] = [
  {
    id: "FREE",
    name: "SARADIUM Free",
    price: "Free",
    description:
      "The essential everyday SARADIUM experience.",
    features: [
      "Spatial Flow design",
      "Core reminders and routines",
      "Malaysia calendar",
      "Receive Event Circle invitations",
    ],
  },
  {
    id: "PREMIUM",
    name: "SARADI Premium",
    price: "RM12.90/month",
    studentPrice: "Verified student price: RM7.90/month",
    description:
      "More planning freedom and Soft Neumorphism.",
    features: [
      "Everything in Free",
      "Soft Neumorphism unlocked",
      "Unlimited reminders and countdowns",
      "Widgets and planning insights",
    ],
  },
  {
    id: "PREMIUM_PLUS",
    name: "SARADI Premium Plus",
    price: "RM16.90/month",
    studentPrice: "Verified student price available",
    description:
      "Full SARADIUM experience and Event Circle hosting.",
    features: [
      "Everything in Premium",
      "Liquid Glass unlocked",
      "Aurora, Lagoon and Coffee palettes",
      "Host Event Circles and invite guests",
    ],
  },
];